import Layout from '@/layout/ezpay-index.vue'

export const operationManageRouter = {
  path: '/operationManage',
  component: Layout,
  redirect: '/operationManage/business-list',
  name: 'Operation_Manage',
  meta: { title: 'operation_manage', icon: 'system', public: true },
  alwaysShow: true,
  children: [
    {
      path: 'business-list',
      name: 'Business_Manage_List',
      component: () => import('@/views/ezpay/operation-manage/business-list.vue'),
      meta: { title: 'business_manage', noCache: false, public: true, auth: ['AUTH_CODE_BUSINESS_MANAGE'] }
    },
    {
      path: 'franchisee-list',
      name: 'Franchisee_Manage_List',
      component: () => import('@/views/ezpay/operation-manage/franchisee-list.vue'),
      meta: { title: 'franchisee_manage', noCache: false, public: true, auth: ['AUTH_CODE_FRANCHISEE_MANAGE'] }
    },
    {
      path: 'franchisee-create',
      name: 'Franchisee_Create',
      hidden: true,
      component: () => import('@/views/ezpay/operation-manage/franchisee-form.vue'),
      meta: { title: 'franchisee_create', noCache: true, activeMenu: '/operationManage/franchisee-list', public: true, auth: ['AUTH_CODE_FRANCHISEE_MANAGE'] }
    },
    {
      path: 'franchisee-edit',
      name: 'Franchisee_Edit',
      hidden: true,
      component: () => import('@/views/ezpay/operation-manage/franchisee-form.vue'),
      meta: { title: 'franchisee_edit', noCache: true, activeMenu: '/operationManage/franchisee-list', public: true, auth: ['AUTH_CODE_FRANCHISEE_MANAGE'] }
    },
    {
      path: 'franchisee-detail',
      name: 'Franchisee_Detail',
      hidden: true,
      component: () => import('@/views/ezpay/operation-manage/franchisee-detail.vue'),
      meta: { title: 'franchisee_detail', noCache: true, activeMenu: '/operationManage/franchisee-list', public: true, auth: ['AUTH_CODE_FRANCHISEE_MANAGE'] }
    }
  ]
}
